import React, { useEffect } from 'react';
// import Head from 'next/head';
import Grid from '@material-ui/core/Grid';

import FullRow from './ui/blocks/FullRow';
import TwoInRow from './ui/blocks/TwoInRow';
import FullRowMiddle from './ui/blocks/FullRowMiddle';
import LineBreak from './ui/blocks/LineBreak';

import hardware from '../assets/images/hardware/hardware.gif';
import construct from '../assets/images/hardware/construct.gif';
import zirsakht from '../assets/images/hardware/zirsakht.gif';
import server from '../assets/images/hardware/server.gif';
import phone from '../assets/images/hardware/phone.gif';
import camera from '../assets/images/hardware/camera.gif';
import fiber from '../assets/images/hardware/fiber.gif';
import fire from '../assets/images/hardware/fire.gif';

export default function Hardware(props) {

    const content = props.content.hardware;
    const language = props.language;

    const setValue = props.setValue;
    const setSelectedIndex = props.setSelectedIndex;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(1);
        setSelectedIndex(1);
    }, [setValue, setSelectedIndex]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="column" dir={language === "per" ? "rtl" : null} style={{ marginTop: "-5em" }}>

                {/* Header */}
                <FullRow content={content.header} image={hardware} language={language} dir={0} imageW={500} />

                {/* Tips */}
                {/* <ThreeInRow content={content.tips} image1={uc} image2={uc} image3={uc} language={language} imageW1={300} imageW2={300} imageW3={300} /> */}
                <LineBreak height="75px" type={0} />

                {/* Seven row */}
                <FullRow content={content.seventhRow} image={construct} language={language} dir={0} imageW={400} />
                <LineBreak height="75px" type={1} />

                {/* First row */}
                <FullRow content={content.firstRow} language={language} dir={0} imageW={450} />

                {/* Second row */}
                <FullRowMiddle content={content.secondRow} image={zirsakht} language={language} imageW={450} />
                <LineBreak height="75px" type={0} />

                {/* Third row */}
                <FullRow content={content.thirdRow} image={server} language={language} dir={0} imageW={450} />
                <LineBreak height="75px" type={1} />

                {/* Fifth row */}
                <TwoInRow content={content.fifthRow} image={phone} language={language} imageW={400} />
                <LineBreak height="75px" type={0} />


                {/* Forth row */}
                <FullRow content={content.forthRow} image={camera} language={language} dir={0} imageW={400} />
                <LineBreak height="75px" type={1} />

                {/* Sixth row */}
                <FullRow content={content.sixthRow} image={fiber} language={language} dir={1} imageW={400} />
                <LineBreak height="75px" type={0} />

                {/* eight row */}
                <FullRow content={content.eighthRow} image={fire} language={language} dir={0} imageW={400} />


            </Grid>

        </React.Fragment>
    )
}